import * as MedKeyTypesDAO from "@/dao/med-key-types-dao";

export default {
  async getMedKeyType({ commit }, { locationId, medKeyType }) {
    const medKey = await MedKeyTypesDAO.getMedKeyTypeName(locationId, medKeyType);
    commit("setCurrentMedKeyTypeName", medKey);
  }
};
